// import { keys } from "ts-transformer-keys";
import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import User from "../../types/User/User";
import userConstants from "../constants/userConstants";

const initialState: {
  users: User[];
  signupRequests: any[];
  userDetails: any;
  count: number;
  singupReqCount: number;
  roles: any[];
  signupReqPending: Boolean;
  signupReqFulfilled: Boolean;
  signupReqError: Boolean;
  updateSignupRequestSuccess: Boolean;
  updateSignupRequestPending: Boolean;

  loginError: Boolean;
  loginPending: Boolean;
  loginFulfilled: Boolean;
  userDetailsSuccess: Boolean;
  logoutFulfilled: Boolean;

  error: Boolean;
  pending: Boolean;
  fulfilled: Boolean;

  usersPending: Boolean;
  signupListPending: Boolean;
} = {
  users: [],
  signupRequests: [],
  userDetails: null,
  count: 0,
  singupReqCount: 0,
  roles: [],
  signupReqPending: false,
  signupReqFulfilled: false,
  signupReqError: false,
  updateSignupRequestSuccess: false,
  updateSignupRequestPending: false,
  loginError: false,
  loginPending: false,
  loginFulfilled: false,
  userDetailsSuccess: false,
  logoutFulfilled: false,

  error: false,
  pending: false,
  fulfilled: false,

  usersPending: false,
  signupListPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case userConstants.GET_USERS_LIST:
      return {
        ...state,
        usersPending: true,
      };
    case userConstants.GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        usersPending: false,
        count: action.payload.data.count,
        users: action.payload.data.results as User[],
      };
    case userConstants.GET_USERS_LIST_FAILURE:
      return {
        ...state,
        usersPending: false,
      };
    case userConstants.GET_ROLES_LIST_SUCCESS:
      return {
        ...state,
        roles: action.payload.data.results,
      };
    case userConstants.GET_USER_SIGNUP_REQUEST:
      return {
        ...state,
        signupListPending: true,
      };
    case userConstants.GET_USER_SIGNUP_SUCCESS:
      return {
        ...state,
        signupListPending: false,
        singupReqCount: action.payload.data.count,
        signupRequests: action.payload.data.results,
      };
    case userConstants.GET_USER_SIGNUP_FAILURE:
      return {
        ...state,
        signupListPending: false,
      };
    case userConstants.CREATE_USER_REQ:
    case userConstants.EDIT_USER_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case userConstants.CREATE_USER_SUCCESS:
    case userConstants.EDIT_USER_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
      };
    case userConstants.CREATE_USER_FAILURE:
    case userConstants.EDIT_USER_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };
    case userConstants.GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.payload.data,
        userDetailsSuccess: true,
      };
    case userConstants.SEND_USER_SIGNUP_REQUEST:
      return {
        ...state,
        signupReqPending: true,
        signupReqFulfilled: false,
        signupReqError: false,
      };
    case userConstants.SEND_USER_SIGNUP_SUCCESS:
      return {
        ...state,
        signupReqPending: false,
        signupReqFulfilled: true,
        signupReqError: false,
      };
    case userConstants.SEND_USER_SIGNUP_FAILURE:
      return {
        ...state,
        signupReqPending: false,
        signupReqFulfilled: false,
        signupReqError: true,
      };
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loginPending: true,
        loginError: false,
        loginFulfilled: false,
        logoutFulfilled: false,
        userDetailsSuccess: false,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loginPending: false,
        loginError: false,
        loginFulfilled: true,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        loginPending: false,
        loginError: true,
        loginFulfilled: false,
      };
    case userConstants.LOGOUT_REQUEST:
      return {
        ...state,
        logoutFulfilled: false,
        loginFulfilled: false,
        userDetailsSuccess: false,
      };
    case userConstants.LOGOUT_SUCCESS:
      return {
        ...state,
        logoutFulfilled: true,
        loginFulfilled: false,
        userDetailsSuccess: false,
      };
    case userConstants.LOGOUT_FAILURE:
      return {
        ...state,
        logoutFulfilled: true,
        loginFulfilled: false,
        userDetailsSuccess: false,
      };
    case userConstants.REFRESH_TOKEN_REQUEST:
      return {
        ...state,
        loginFulfilled: false,
        userDetailsSuccess: false,
      };
    case userConstants.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
      };
    case userConstants.UPDATE_SIGNUP_REQUEST:
      return {
        ...state,
        updateSignupRequestSuccess: false,
        updateSignupRequestPending: true,
      };
    case userConstants.UPDATE_SIGNUP_SUCCESS:
      return {
        ...state,
        updateSignupRequestSuccess: true,
        updateSignupRequestPending: false,
      };
    case userConstants.UPDATE_SIGNUP_FAILURE:
      return {
        ...state,
        updateSignupRequestSuccess: false,
        updateSignupRequestPending: false,
      };
    case userConstants.RESET_SIGNUP_REQUEST:
      return {
        ...state,
        signupReqPending: false,
        signupReqFulfilled: false,
        signupReqError: false,
        updateSignupRequestSuccess: false,
        updateSignupRequestPending: false,
      };
    case userConstants.RESET_USERS:
      return {
        ...state,
        users: [],
        count: 0,

        singupReqCount: 0,
        signupRequests: [],
      };
    default:
      return {
        ...state,
      };
  }
};
